export const MuiPaper = (palette) => ({
  styleOverrides: {
    root: {
      padding: '24px',
      borderRadius: '12px',
      border: `1px solid ${palette.custom.stroke2}`,
      background: palette.custom.widgetBg,
      boxShadow: 'none',
    },
  },
});
